// @flow

import { clientCommunicationActions } from './clientCommunicationActionCreator';

const initialState = {
  fetchingInitialPageDetails: false,
  fetchedInitialPageDetails: true,
  ccPageData: null,
  errorMessage: null,
  defaultUserSettings: {
    isLoading: false,
    isLoaded: false,
    data: null
  },
  ccPageDataClientWiseFiltered: null,
  userOptionsList: [],
  postCallProgress: false,
  postCallCompleted: false
};

const getFilteredClientList = (searchString, state) => {
  const searchStringLowerCase = searchString.toLowerCase().trim();
  const pageData = state.ccPageData;
  let filteredArr;

  if (searchStringLowerCase && pageData) {
    filteredArr = pageData.filter(
      row =>
        (row.clientCode &&
          row.clientCode.toLowerCase().indexOf(searchStringLowerCase) >= 0) ||
        (row.displayName &&
          row.displayName.toLowerCase().indexOf(searchStringLowerCase) >= 0)
    );
  } else {
    filteredArr = pageData;
  }
  return filteredArr;
};

const clientCommunicationReducer = (
  state: Object = initialState,
  action: Object
) => {
  switch (action.type) {
    case clientCommunicationActions.GET_USER_CLIENTS: {
      return Object.assign({}, state, action.payload);
    }
    case clientCommunicationActions.GET_DEFAULT_USER_SETTINGS: {
      return Object.assign({}, state, action.payload);
    }
    case clientCommunicationActions.FILTER_CLIENT_LIST: {
      const filteredClientList = getFilteredClientList(action.payload, state);
      return Object.assign({}, state, {
        ccPageDataClientWiseFiltered: filteredClientList,
        errorMessage: filteredClientList.length ? null : 'No clients found'
      });
    }
    case clientCommunicationActions.GET_USER_OPTIONS_LIST: {
      return Object.assign({}, state, action.payload);
    }
    case clientCommunicationActions.ADD_USER: {
      return Object.assign({}, state, action.payload);
    }
    case clientCommunicationActions.EDIT_USER: {
      return Object.assign({}, state, action.payload);
    }
    default: {
      return state;
    }
  }
};

export default clientCommunicationReducer;
